import { css } from '@eti/styles';
import type { HeadingTypes } from '@etg/wings';
import { Card, Stack, vars } from '@etg/wings';
import { Accordion } from '@eti/components';
import { useProperty, useTranslation } from '@eti/providers';
import Chat from '../../pages/contact-us/components/Chat';
import Call, { CallHeader } from '../../pages/contact-us/components/Call';
import type { ChatType } from '../chat/models';

const cardStyles = css`
  background-color: #fafafa;
  border: 1px solid ${vars.colors.divider};
`;

const resetCallStyles = css`
  border: unset;
  padding: 16px 0 0;
`;

const supportNoteWrapperStyles = css`
  font-size: 0.75rem;
`;

interface ContactMethodsProps {
  shouldShowChat?: boolean;
  isCallExpanded?: boolean;
  chatType?: ChatType;
  headingAs?: `h${HeadingTypes['level']}` | 'h5';
  snowplowProperty?: string;
}

const ContactMethods = ({
  shouldShowChat = true,
  isCallExpanded = false,
  chatType,
  headingAs,
  snowplowProperty,
}: ContactMethodsProps) => {
  const { p } = useProperty();
  const { t } = useTranslation();
  const isChatEnabled =
    shouldShowChat &&
    (p('Chat.WebMessages.Enabled') || p('Chat.Widget.Enabled') || p('Chatbot.Oriana.Enabled'));

  return (
    <Stack
      aria-label={t('ScreenReader.ContactMethods.Group.Text')}
      data-testid="contact-methods"
      role="group"
      spacing={8}
    >
      {isChatEnabled && chatType && (
        <Chat chatType={chatType} headingAs={headingAs} snowplowProperty={snowplowProperty} />
      )}
      <Card className={cardStyles}>
        <Accordion
          id="changeable-order-call-accordion"
          isInitiallyExpanded={isCallExpanded}
          variant="full-width"
        >
          <Accordion.Header data-testid="expansion-panel-changeable-order-call">
            <CallHeader headingAs={headingAs} />
          </Accordion.Header>
          <Accordion.Body>
            <Call className={resetCallStyles} headingAs={headingAs} shouldShowHeader={false} />
          </Accordion.Body>
        </Accordion>
      </Card>
      <div className={supportNoteWrapperStyles}>{t('ContactUs.ContactMethods.SupportNote')}</div>
    </Stack>
  );
};

export default ContactMethods;
